module.exports = __webpack_public_path__ + "img/logo_head.e0252ece.svg";